import type { Target } from 'src/models/TimerTarget';

import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { Style } from 'src/constants';
import { useTimer } from 'src/contexts';

import TimerButton from './TimerButton';
import TimerCategorySelect from './TimerCategorySelect';

type Props = {
  target: Target;
  style?: css.StyleXStyles;
};

/**
 * A timer with whatever it needs beside it.  Work which cannot say what its
 * time went on picks a category first, and will not start without one; the
 * rest is just the button.
 */
export default function TimerControls({ target, style }: Props) {
  const timer = useTimer();
  const [chosen, setChosen] = React.useState<string | null>(null);

  const running = timer.isRunning(target);
  // While the clock is going, the category is whatever it was started under.
  const category = running ? timer.running?.categoryString ?? null : chosen;

  return (
    <html.div style={[Style.row, Style.alignCenter, styles.controls, style]}>
      <TimerCategorySelect
        target={target}
        value={category}
        onChange={setChosen}
        disabled={running}
      />
      {/* The button holds itself shut until the category is picked. */}
      <TimerButton target={target} category={category} />
    </html.div>
  );
}

const styles = css.create({
  controls: {
    flexShrink: 0,
    gap: 10,
  },
});
